<tool-drawer-container (openFormDialog)="openDialog()">
  <entry-exit-flow-form class="form-slot"></entry-exit-flow-form>

  <tool-header
    class="tool-header"
    headerTitle="Entry or Exit Flow Graph"
    subtitle="Displays student flow in and out of a program [Forward: Flow out; Backward: Flow in]"
  ></tool-header>

  <entry-exit-flow-info-content
    class="main-content"
  ></entry-exit-flow-info-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'Entry or Exit Flow Graph'
      )
    "
  ></related-links>
</tool-drawer-container>
